import React from "react";
import SquadSelect from "./SquadSelect";
import {
  squadFilterFromValue,
  squadFilterValue,
} from "./scoringFilterOptions";

const selectClassName = (compact) =>
  compact
    ? "h-11 min-h-11 min-w-[11rem] max-w-full sm:max-w-[18rem] px-3 text-sm border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
    : "w-full px-3 py-2 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink";

const FilterPanel = ({
  filters,
  onFiltersChange,
  squads,
  events,
  onClearFilters,
  compact = false,
  showEvent = true,
  showClear = true,
}) => {
  const eventOptions = [
    { value: "all", label: "All events" },
    ...(events || []).map((event) => ({
      value: event.id,
      label: event.eventName,
    })),
  ];
  const hasActiveFilters =
    filters.squad !== "all" ||
    filters.event !== "all" ||
    filters.date !== "all" ||
    Boolean(filters.search);

  const handleSquadChange = (value) => {
    onFiltersChange({
      ...filters,
      ...squadFilterFromValue(value),
    });
  };

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value,
    });
  };

  const squadSelect = (
    <SquadSelect
      squads={squads}
      value={squadFilterValue(filters)}
      onChange={handleSquadChange}
      allLabel="All squads"
      compact={compact}
    />
  );

  const eventSelect =
    showEvent && (events || []).length > 1 ? (
      <select
        aria-label="Event"
        value={filters.event}
        onChange={(event) => handleFilterChange("event", event.target.value)}
        className={selectClassName(compact)}
      >
        {eventOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    ) : null;

  const clearButton =
    showClear && hasActiveFilters && onClearFilters ? (
      <button
        type="button"
        onClick={onClearFilters}
        className={`text-sm font-display font-bold text-brand-muted hover:text-brand-charcoal ${
          compact ? "inline-flex items-center min-h-11 px-2" : "px-4 py-2 border border-brand-charcoal/20 rounded-lg hover:bg-brand-charcoal/5"
        }`}
      >
        Clear
      </button>
    ) : null;

  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        {squadSelect}
        {eventSelect}
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:items-end">
      <div className="min-w-[12rem] flex-1">
        <label className="block text-sm font-medium text-brand-charcoal mb-2">
          Squad
        </label>
        {squadSelect}
      </div>
      {eventSelect ? (
        <div className="min-w-[12rem] flex-1">
          <label className="block text-sm font-medium text-brand-charcoal mb-2">
            Event
          </label>
          {eventSelect}
        </div>
      ) : null}
      {clearButton}
    </div>
  );
};

export default FilterPanel;
